<template>
  <div class="path">
    <span><router-link to="/"> 首页</router-link></span>
    &nbsp; &gt; &nbsp;
    <span>{{formulaType}}</span>
  </div>
  <div class="card-box">
    <div class="title-box">
      <div class="title-box-title">{{formulaType}}</div>
    </div>
    <el-empty description="暂无数据" v-if="!tableLoading && !list.length"></el-empty>
    <el-row :gutter="20" v-loading="tableLoading">
      <el-col :span="6" v-for="item in list" :key="item.id" @click="toDatail(item.id)" style="margin-top: 20px;">
        <el-card :body-style="{ padding: '0px' }" shadow="hover">
          <div class="img-box">
            <div class="bg" :style="{ backgroundImage: `url(${item.thumbnailUrl})` }"></div>
          </div>
          <div style="padding: 14px;">
            <div class="title-n">{{ item.title }}</div>
            <div class="bottom clearfix">
              <time class="time">{{ currentDate }}</time>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="pagination">
      <el-pagination v-if="windowWidth >= 768" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 15, 20, 30, 40]"
        :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total='tableTotal'>
      </el-pagination>
      <el-pagination v-else @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :pager-count="3" :page-size="pagesize" layout="total, prev, pager, next"
        :total='tableTotal'>
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  // 接收父组件传值
  props: {
    windowWidth: Number
  },
  data() {
    return {
      tableLoading: false,
      currentPage: 1,
      pagesize: 20,
      tableTotal: 0,
      list: [],
      anTypeList: [
        {
          id: 'GC0020001',
          label: '政策公示'
        },
        {
          id: 'GC0020002',
          label: '活动公告'
        },
        {
          id: 'GC0020003',
          label: '农残检测公示'
        },
        {
          id: 'GC0020004',
          label: '计量器具抽检公示'
        },
        {
          id: 'GC0020005',
          label: '培训演练'
        },
        {
          id: 'GC0020006',
          label: '智慧党建'
        }
      ]
    }
  },
  computed: {
    type() {
      return this.$route.params.id
    },
    formulaType() {
      return this.anTypeList.find(e => e.id === this.type)?.label
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // pageSize 新每页条数改变时触发(每页下拉显示数据)
    handleSizeChange(size) {
      this.pagesize = size
      this.getListData()
    },
    // 新当前页改变时触发(点击第几页)
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getListData()
    },
    async getListData() {
      var en = {
        "position": "info_queryInfoList",
        "paramMap": {
          "parentOrgId": "c4ea4992ffc14621af7953512a94bda9",
          "title": "",
          "isRelease": "1",
          "formulaType": this.type
        },
        "pageable": {
          "pageNumber": this.currentPage,
          "pageSize": this.pagesize
        }
      }
      const { data: res } = await this.$http.post(this.$api.queryInfoList, en)
      if (res.state.code === 10000) {
        this.list = res.body.list
        this.tableTotal = res.body.totalCount
      } else {
        this.$message.error(res.state.message)
      }
      this.tableLoading = false
    },
    toDatail(id) {
      this.$router.push(`/publicnoticedetail?id=${id}`)
    }
  }
}
</script>

<style scoped>
.title-n {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1em;
}


.bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: auto;
  height: auto;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-color: #F6F8F9;
}

.bg::before {
  content: " ";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  top: 176rpx;
  background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.img-box {
  position: relative;
  width: 100%;
  padding-top: calc(100% / (2.35));
  background-color: lightblue;
}

.image {
  width: 100%;
  height: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>